import React from "react";
import { FontStyles } from "../utils/font-styles.ts";
import { SectionHeader } from "../components/section-header.tsx";
import { PropertyCard, PropertyCardProps } from "../components/property-card/property-card.tsx";

export const RecentlyViewedProperties: React.FC<{ items: PropertyCardProps[] }> = ({ items }) => {
  if (items.length === 0) return null;

  return (
    <div className={"flex flex-col gap-3 md:gap-3.5"}>
      <SectionHeader text={"Recently viewed"} as="h2" className={`leading-none md:leading-none ${FontStyles.h5}`} />
      <div className="flex flex-col md:grid md:grid-cols-3 gap-4.5 md:gap-3.5">
        {items.map((property) => (
          <PropertyCard {...property} key={property.id} />
        ))}
      </div>
    </div>
  );
};
